import { globalState } from '@/store'
import reportAction from '@/utils/statistic'
import { type SetStateAction, useEffect, useState } from 'react'
import Home from './widget/home'
import Industry from './widget/industry'
import ProductCenter from './widget/productCenter'
import Navbar from './widget/navbar'
import { navbar } from './config'
import Footer from './widget/footer'

export interface Anchor {
  anchor: string
  timestamp: number
}

export default () => {
  const [activeNav, setActiveNav] = useState<any>(navbar[0])
  const [anchorPoint, setAnchorPoint] = useState<Anchor>({
    anchor: '',
    timestamp: 0,
  })

  useEffect(() => {
    const { userInfo } = globalState
    reportAction({
      action: 'home',
      user_id: userInfo.id,
    })
  }, [])

  const setNavAndAnchor = (nav: any, anchor: SetStateAction<Anchor>) => {
    setActiveNav(nav)
    setAnchorPoint(anchor)
  }

  const getContent = () => {
    switch (activeNav.key) {
      case 'home':
        return <Home />
      case 'productCenter':
        return <ProductCenter anchorPoint={anchorPoint} />
      case 'industry':
        return <Industry anchorPoint={anchorPoint} />
      default:
        break
    }
  }

  return (
    <div
      style={{ fontFamily: 'Source Han Sans CN' }}
      className="bg-[#000000] w-full h-full flex flex-col overflow-x-hidden"
    >
      <Navbar activeNav={activeNav} setActiveNavAndAnchor={setNavAndAnchor} />
      <div className="flex-1">{getContent()}</div>
      <Footer />
    </div>
  )
}
